export * from "./extracted-data-fetcher";
